
export default {
  install(Vue) {

    const methods = {
      isEmpty(value, ...ignores) {
        return !this.isNotEmpty(value, ignores)
      },
      toDateInput(date = new Date()) {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      },
      isNotEmpty(value, ...acept) {
        if (acept.includes(value))
          return true
        else if (value === null || typeof value === 'undefined')
          return false;
        else if (typeof value === 'number')
          return true
        else if (Array.isArray(value) || typeof value === 'string')
          return value.length > 0
        else if (typeof value === 'object')
          return Object.keys(value).length > 0
        else
          return value
      }
    }

    Vue.utils = methods
    Vue.prototype.$utils = methods
  }
}
